// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes interested-companies-skeleton-shimmer{from{background-position:-400px 0}to{background-position:calc(400px + 100%) 0}}.interested-companies-loading{display:flex;grid-gap:16px;gap:16px;overflow:hidden}.interested-companies-loading__card{flex:0 0 150px;height:210px;background:linear-gradient(90deg, #f0f0f0 25%, #e4e4e4 50%, #f0f0f0 75%);background-size:400px 100%;animation:interested-companies-skeleton-shimmer 1.5s ease-in-out infinite;border-radius:8px}", ""]);
// Exports
module.exports = exports;
